import React from 'react'
import PropTypes from 'prop-types'
import style from './PasswordScore.module.css'
import withTranslation from 'next-translate/withTranslation'

export function scorePassword (value) {
  let score = 0
  if (value?.length >= 5) {
    score += value.length >= 8 ? 1 : 0
    score += value.match(/[a-z]/) ? 1 : 0
    score += value.match(/[A-Z]/) ? 1 : 0
    score += value.match(/[0-9]/) ? 1 : 0
    score += value.match(/[^a-z0-9]/i) ? 1 : 0
    score += score === 5 && value.length >= 12 ? 1 : 0
  }
  return score
}
class PasswordScore extends React.PureComponent {
  render () {
    let score = parseInt(this.props.score, 10) || scorePassword(this.props.value)
    score = score > 6 ? 6 : (score < 0 ? 0 : score)
    let count = 1

    const { t } = this.props.i18n

    const labels = [
      '',
      t('default:passwordscore_1'),
      t('default:passwordscore_2'),
      t('default:passwordscore_3'),
      t('default:passwordscore_4'),
      t('default:passwordscore_5'),
      t('default:passwordscore_6')
    ]

    return (
      <div className={style.score}>
        {labels.slice(1, 7).map(l => (
          <span key={count++} className={(score >= count ? style['score' + count] : '')} title={l} />
        ))}
        <output aria-live={labels[score]}>{labels[score]}</output>
      </div>
    )
  }
}

PasswordScore.propTypes = {
  value: PropTypes.string,
  score: PropTypes.number
}

export default withTranslation(PasswordScore)
